<template>
  <div>
    <h1 class="text-center">Interview Question List</h1>
    <router-link
      class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-2 hover:bg-green-900 no-underline rounded-full inline-block"
      to="/interview-question-new"
    >
      Create Interview Question
    </router-link>
    <Table :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}admin/questions?search_by_type=7&fields=id,name,reading_time,type,time_allocated`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
          classList: "w-1/2",
        },
        { header: { textContent: "Id" }, path: "id" },
        {
          header: {
            textContent: "Buffer Time",
            sortingParam: "reading_time",
          },
          path: "reading_time",
        },
        {
          header: {
            textContent: "Allocated time",
            sortingParam: "time_allocated",
          },
          path: "time_allocated",
        },
        {
          header: {
            textContent: "Option",
          },

          path: "id",
          type: "action",
          actionButtonText: "Edit",
          routePath: "/interview-question-edit/:readingId",
        },
      ],
    }
  },
}
</script>
